import React, { useState, useEffect } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall.ts';
import './IOSInstallInstructions.css';

const IOSInstallInstructions: React.FC = () => {
  const { isInstalled, isIOS } = usePWAInstall();
  const [showInstructions, setShowInstructions] = useState(false);

  useEffect(() => {
    if (isIOS && !isInstalled) {
      // Mostrar instruções após 5 segundos no iOS
      const timer = setTimeout(() => {
        setShowInstructions(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isIOS, isInstalled]);

  const handleClose = () => {
    setShowInstructions(false);
    // Não mostrar novamente por 7 dias
    localStorage.setItem('ios-install-dismissed', Date.now().toString());
  };

  // Verificar se foi dispensado recentemente
  const dismissedTime = localStorage.getItem('ios-install-dismissed');
  if (dismissedTime) {
    const timeDiff = Date.now() - parseInt(dismissedTime);
    if (timeDiff < 7 * 24 * 60 * 60 * 1000) { // 7 dias
      return null;
    }
  }

  if (!isIOS || !showInstructions || isInstalled) {
    return null;
  }

  return (
    <div className="ios-install-overlay">
      <div className="ios-install-modal">
        <div className="ios-install-header">
          <h3>📱 Instalar Prumo</h3>
          <button className="ios-install-close" onClick={handleClose}>
            ✕
          </button>
        </div>
        
        <div className="ios-install-content">
          <p>Para instalar este app no seu iPhone/iPad:</p>
          
          <div className="ios-install-steps">
            <div className="ios-step">
              <div className="ios-step-number">1</div>
              <div className="ios-step-text">
                Toque no botão de compartilhar <span className="ios-icon">📤</span> na parte inferior da tela
              </div>
            </div>
            
            <div className="ios-step">
              <div className="ios-step-number">2</div>
              <div className="ios-step-text">
                Role para baixo e toque em <strong>"Adicionar à Tela de Início"</strong>
              </div>
            </div>
            
            <div className="ios-step">
              <div className="ios-step-number">3</div>
              <div className="ios-step-text">
                Toque em <strong>"Adicionar"</strong> para confirmar
              </div>
            </div>
          </div>
          
          <div className="ios-install-benefits">
            <h4>✨ Benefícios da instalação:</h4>
            <ul>
              <li>🚀 Acesso rápido direto da tela inicial</li>
              <li>📱 Funciona offline</li>
              <li>🔔 Notificações push</li>
              <li>💾 Dados sincronizados</li>
            </ul>
          </div>
        </div>
        
        <div className="ios-install-footer">
          <button className="ios-install-got-it" onClick={handleClose}>
            Entendi!
          </button>
        </div>
      </div>
    </div>
  );
};

export default IOSInstallInstructions;
